import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";
import Moment from "moment";

export const getPurchaseRequest = async (data) => {

    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "purchase_requests/get",
            {
                requester: getUser(),
                token: getToken(),
                purchase_request_id: data.id ? data.id : "",
                branch: data.branch ? data.branch : "",
                branch_id: data.branch_id ? data.branch_id : "",
                department_id: data.department_id ? data.department_id : "",
                status: data.tab ? data.tab : "",
                purchase_request_date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
                purchase_request_date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                request_date: data.request_date ? Moment(data.request_date).format("YYYY-MM-DD") : "",
                required_date: data.required_date ? Moment(data.required_date).format("YYYY-MM-DD") : "",
                // pr_no: data.pr_no ? data.pr_no : "",
                remarks: data.remarks ? data.remarks : "",
                limit: data.limit ? data.limit : "",
                page: data.page ? data.page : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const deletePurchaseRequest = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_requests/delete",
            {
                requester: getUser(),
                token: getToken(),
                purchase_request_id: id,
                // requested_by: getUser(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const updatePurchaseRequestStatus = async (id, status) => {
    
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("purchase_request_id", id);
    form_data.append("status", status);
    form_data.append("requested_by", getUser());

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_requests/update_status", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
    
    // try {
    //     const response = await getAPICall(
    //         process.env.REACT_APP_LINK + "purchase_requests/update_status",
    //         {
    //             requester: getUser(),
    //             token: getToken(),
    //             purchase_request_id: id,
    //             status: status,
    //             requested_by: requested_by,
    //         }
    //     );
    //     return { data: response.data };
    // } catch (error) {
    //     return { error: error.response };
    // }
};

// export const recordActionPurchaseRequest = async (id, action) => {
//     try {
//         const response = await getAPICall(
//             process.env.REACT_APP_LINK + "purchase_requests/send_email_to_supplier",
//             {
//                 requester: getUser(),
//                 token: getToken(),
//                 purchase_request_id: id,
//                 action: action,
//             }
//         );
//         return { data: response.data };
//     } catch (error) {
//         return { error: error.response };
//     }
// };

export const addPurchaseRequestNote = async (id, remarks) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("requested_by", getUser());
    form_data.append("purchase_request_id", id);
    form_data.append("purchase_request_remarks", remarks);

    // purchase_request_remarks.map((item) => {
    //     form_data.append('classifications[]', item.classification);
    // });

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_requests/add_purchase_request_remarks", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// FOR CREATING PURCHASE REQUEST
export const createPurchaseRequest = async (data, items, files, status) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("department_id", data.department_id);
    form_data.append("request_date", data.request_date);
    form_data.append("required_date", data.required_date);
    form_data.append("requested_by", data.requested_by);
    form_data.append("oic", data.oic);
    form_data.append("remarks", data.remarks);
    form_data.append("branch", "test");
    form_data.append("branch_id", data.branch_id);
    form_data.append("status", status);

    items.map((item) => {
        form_data.append('descriptions[]', item.description ? item.description : "");
    });

    items.map((item) => {
        form_data.append('quantities[]', item.quantity ? item.quantity : "");
    });

    items.map((item) => {
        form_data.append('item_purposes[]', item.purpose ? item.purpose : "");
    });
    
    items.map((item) => {
        form_data.append('item_remarks[]', item.remarks ? item.remarks : "");
    });
    
    items.map((item) => {
        form_data.append('uoms[]', item.uom ? item.uom : "");
    });
    
    items.map((item) => {
        form_data.append('selling_prices[]', item.selling_price ? item.selling_price : "");
    });
    
    items.map((item) => {
        form_data.append('purchase_request_remarks[]', item.purchase_request_remark ? item.purchase_request_remark : "");
    });
    
    files.map((file) => {
        form_data.append('attachments[]', file, file.name);
    });

    // Array.from(files).map(val=> formData.append("attachments[]", val))

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_requests/create", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updatePurchaseRequest = async (data, items, files, status) => {
    let form_data = new FormData();
    form_data.append("requester", getUser());
    form_data.append("token", getToken());
    form_data.append("purchase_request_id", data.id);
    form_data.append("department_id", data.department_id);
    form_data.append("request_date", data.request_date);
    form_data.append("required_date", data.required_date);
    form_data.append("requested_by", data.requested_by);
    form_data.append("oic", data.oic);
    form_data.append("remarks", data.remarks);
    form_data.append("branch", "test");
    form_data.append("branch_id", data.branch_id);
    form_data.append("status", status);

    items.map((item) => {
        form_data.append('descriptions[]', item.description ? item.description : "");
    });

    items.map((item) => {
        form_data.append('quantities[]', item.quantity ? item.quantity : "");
    });

    items.map((item) => {
        form_data.append('item_purposes[]', item.purpose ? item.purpose : "");
    });
    
    items.map((item) => {
        form_data.append('item_remarks[]', item.remark ? item.remark : "");
    });
    
    items.map((item) => {
        form_data.append('uoms[]', item.uom ? item.uom : "");
    });
    
    items.map((item) => {
        form_data.append('selling_prices[]', item.selling_price ? item.selling_price : "");
    });
    
    items.map((item) => {
        form_data.append('purchase_request_remarks[]', item.purchase_request_remark ? item.purchase_request_remark : "");
    });
    
    files.map((file) => {
        form_data.append('attachments[]', file, file.name);
        form_data.append('attachment_ids[]', null);
    });

    data.prev_files.map((file) => {
        form_data.append('attachment_ids[]', file.id);
    });

    // Array.from(files).map(val=> formData.append("attachments[]", val))

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "purchase_requests/update", form_data
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};